import React, {
  Fragment,
  ChangeEvent,
  useContext,
  useState,
  KeyboardEvent,
} from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import {
  Typography,
  MenuItem,
  TextField,
  InputAdornment,
  IconButton,
  Popover,
} from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import {
  scaleList,
  scaleTextToZoomLevel,
  zoomLevelToScaleText,
} from "../../constant/commons";
import { DesignContext } from "../../context/design";

const useStyles = makeStyles((theme: Theme) => ({
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  spaceInGroup: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  select: {
    height: theme.spacing(4),
    width: 145,
    "& .MuiOutlinedInput-adornedEnd": { paddingRight: 0 },
    "& .MuiOutlinedInput-inputMarginDense": {
      paddingTop: 6.5,
      paddingBottom: 6.5,
    },
  },
}));

const ScaleMap = () => {
  const classes = useStyles();
  const { map } = useContext(DesignContext);
  const [anchorEl, setanchorEl] = useState<null | HTMLElement>(null);
  const [scaleText, setscaleText] = useState<string>("");
  const [zoom, setzoom] = useState<number>(0);

  const _changeInputScale = (event: ChangeEvent<HTMLInputElement>) => {
    setscaleText(event.target.value);
  };

  return (
    <Fragment>
      <Typography variant="subtitle2" className={clsx(classes.flexMiddle)}>
        Scale :
      </Typography>
      <TextField
        className={clsx(classes.spaceInGroup, classes.select)}
        inputProps={{
          type: "number",
          min: 75,
          max: 40000000,
          step: 1,
        }}
        onKeyPress={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.charCode === 13) {
            const scaleNum =
              Number(scaleText) < 75
                ? 75
                : Number(scaleText) > 40000000
                ? 40000000
                : Number(scaleText);

            setscaleText(String(scaleNum));
            const zoomLvl = scaleTextToZoomLevel(scaleNum);
            map?.zoomTo(zoomLvl);
            setzoom(zoomLvl);
            setanchorEl(null);
          }
        }}
        InputProps={{
          startAdornment: <InputAdornment position="start">1:</InputAdornment>,
          endAdornment: (
            <IconButton
              size="small"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                setanchorEl(event.currentTarget);
              }}
            >
              <ArrowDropDown />
            </IconButton>
          ),
        }}
        margin="dense"
        variant="outlined"
        value={scaleText}
        onChange={_changeInputScale}
      />
      <Popover
        id={"scale-menu"}
        open={Boolean(anchorEl)}
        onClose={() => {
          setanchorEl(null);
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {scaleList.map((scale) => (
          <MenuItem
            key={scale.scale}
            selected={Boolean(zoom === scale.zoom)}
            onClick={() => {
              map?.zoomTo(Number(scale.zoom));
              setzoom(Number(scale.zoom));
              setscaleText(zoomLevelToScaleText(scale.zoom).toFixed(0));
              setanchorEl(null);
            }}
          >
            {scale.scale}
          </MenuItem>
        ))}
      </Popover>
    </Fragment>
  );
};

export default ScaleMap;
